import { formatDate } from "../../../utils/functions";

export const formatFiltersReports = (filters) => {
  const formattedFilters = { ...filters };
  if (formattedFilters.periodFrom) {
    formattedFilters.periodFrom = formatDate(formattedFilters.periodFrom);
  }

  if (formattedFilters.periodTo) {
    formattedFilters.periodTo = formatDate(formattedFilters.periodTo);
  }

  return formattedFilters;
};
